/**
 * @file TabelaGeral.js
 * @description View para a tabela de classificação geral.
 */
import React, { useState } from "react";
import { ChevronDown, ChevronRight, Star, } from "lucide-react";
import { getEscudoUrl } from "../api/ligaApi";

const TabelaClassificacaoGeral = ({ equipes, rodadasData }) => {
  const [expandedEquipeId, setExpandedEquipeId] = useState(null);

  const handleToggleExpand = (equipeId) => {
    setExpandedEquipeId((prevId) => (prevId === equipeId ? null : equipeId));
  };

  const calcularPontuacaoTotalEquipe = (equipeId) => {
    return rodadasData
      .filter(
        (p) => p.equipe_id && p.equipe_id.toString() === equipeId.toString(),
      )
      .reduce((acc, curr) => acc + curr.pontos, 0);
  };

  const calcularPontuacaoTotalTime = (timeId) => {
    return rodadasData
      .filter((p) => p.time_id && p.time_id.toString() === timeId.toString())
      .reduce((acc, curr) => acc + curr.pontos, 0);
  };

  const leaderboard = equipes
    .map((equipe) => ({
      ...equipe,
      pontuacaoGeral: calcularPontuacaoTotalEquipe(equipe.id),
      times: equipe.times
        .map((time) => ({
          ...time,
          pontuacaoGeral: calcularPontuacaoTotalTime(time.id),
        }))
        .sort((a, b) => b.pontuacaoGeral - a.pontuacaoGeral),
    }))
    .sort((a, b) => b.pontuacaoGeral - a.pontuacaoGeral);

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left">
        <thead className="bg-gray-700/50">
          <tr>
            <th className="p-2 sm:p-3 w-12 text-sm sm:text-base">#</th>
            <th className="p-2 sm:p-3 text-sm sm:text-base">Equipe</th>
            <th className="p-2 sm:p-3 text-right text-sm sm:text-base">
              Pontuação Geral
            </th>
          </tr>
        </thead>
        <tbody>
          {leaderboard.map((equipe, index) => (
            <React.Fragment key={equipe.id}>
              <tr
                className="border-b border-gray-700 hover:bg-gray-700/30 cursor-pointer"
                onClick={() => handleToggleExpand(equipe.id)}
              >
                <td className="p-2 sm:p-3 font-bold">{index + 1}</td>
                <td className="p-2 sm:p-3 flex items-center text-base sm:text-lg font-semibold">
                  <img
                    src={
                      getEscudoUrl(equipe.logo_url) || "/logo-equipe-padrao.png"
                    }
                    alt=""
                    className="w-8 h-8 mr-3 rounded-full object-contain"
                  />
                  {equipe.nome}
                  {equipe.titulos > 0 && (
                    <div
                      className="relative flex items-center justify-center w-6 h-6 ml-2"
                      title={`${equipe.titulos} Títulos`}
                    >
                      <Star
                        size={24}
                        className="text-yellow-400 fill-yellow-400"
                      />
                      <span className="absolute inset-0 flex items-center justify-center text-[10px] font-bold text-gray-900 pt-[1px]">
                        {equipe.titulos}
                      </span>
                    </div>
                  )}
                </td>
                <td className="p-2 sm:p-3 text-right font-bold text-teal-400 text-base sm:text-lg">
                  {equipe.pontuacaoGeral.toFixed(2)}
                </td>
              </tr>
              {expandedEquipeId === equipe.id && (
                <tr className="bg-gray-900/50">
                  <td colSpan="3" className="p-0">
                    <div className="p-2 sm:p-4 sm:pl-12">
                      <h4 className="text-sm font-semibold text-gray-400 mb-2">
                        Detalhes da Equipe (Pontuação Acumulada)
                      </h4>
                      <div className="space-y-2">
                        {equipe.times
                          .sort((a, b) =>
                            a.nome_time.localeCompare(b.nome_time),
                          )
                          .map((time) => (
                            <div
                              key={time.id}
                              className="flex justify-between items-center bg-gray-800/50 p-2 rounded"
                            >
                              <div className="flex items-center">
                                <img
                                  src={getEscudoUrl(time.escudo_url)}
                                  alt={`Escudo do ${time.nome_time}`}
                                  className="w-6 h-6 rounded-full mr-3"
                                />
                                <div>
                                  <p className="font-semibold text-sm flex items-center">
                                    {time.nome_time}
                                    {time.is_captain && (
                                      <span className="ml-2 text-yellow-400 font-bold text-xs">
                                        (C)
                                      </span>
                                    )}
                                  </p>
                                  <p className="text-xs text-gray-500">
                                    {time.nome_cartoleiro}
                                  </p>
                                </div>
                              </div>
                              <p className="font-semibold text-teal-500 text-sm">
                                {time.pontuacaoGeral.toFixed(2)} pts
                              </p>
                            </div>
                          ))}
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TabelaClassificacaoGeral;
